import { inject, Injectable, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export type Theme = 'light' | 'dark';
export type ThemeIcon = 'light_mode' | 'dark_mode';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly document = inject(DOCUMENT);
  private readonly currentTheme = signal<Theme>('light');

  constructor() {
    this.setTheme(this.getStoredTheme());
  }

  toggleTheme() {
    this.setTheme(this.currentTheme() === 'light' ? 'dark' : 'light');
  }

  setTheme(theme: Theme) {
    this.currentTheme.set(theme);
    this.document.documentElement.classList.toggle('dark-mode', theme === 'dark');
    this.setStoredTheme(theme);
  }

  setStoredTheme(theme: Theme) {
    localStorage.setItem('selected-theme', theme);
  }

  getStoredTheme() {
    return localStorage.getItem('selected-theme') as Theme ?? 'dark';
  }

  getThemeIcon() {
    return this.currentTheme() === 'light' ? 'dark_mode' : 'light_mode';
  }

}
